class SensenCartNotification {
  constructor() {
    this.popup = document.getElementById('SensenCartNotificationPopup');
    if (!this.popup) return;

    this.bodyEl = document.getElementById('SensenCartNotificationBody');
    this.subtotalEl = this.popup.querySelector('[data-cart-subtotal]');
    this.autoCloseTimer = null;

    this.init();
  }

  init() {
    this.isHovered = false;

    this.popup.addEventListener('mouseenter', () => {
      this.isHovered = true;
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
    });

    this.popup.addEventListener('mouseleave', () => {
      this.isHovered = false;
      if (this.popup.getAttribute('aria-hidden') === 'false') {
        this.autoCloseTimer = setTimeout(() => {
          this.close();
        }, 3000);
      }
    });

    document.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('[data-cart-notification-close]') || e.target.closest('.sensen-cart-notification__close');
      if (closeBtn && this.popup.getAttribute('aria-hidden') === 'false') {
        this.close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup.getAttribute('aria-hidden') === 'false') {
        this.close();
      }
    });

    if (window.pubsub && window.PUB_SUB_EVENTS) {
      window.pubsub.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && event.source === 'sensen-cart-notification') return;
        this.fetchCartAndShow(event);
      });
    }
  }

  formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  getSizedImageUrl(src, width) {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch {
      return src;
    }
  }

  async fetchCartAndShow(lastAddedItemData = null) {
    try {
      const res = await fetch(window.routes.cart_url + '.js');
      if (!res.ok) return;
      const cart = await res.json();

      if (cart && typeof cart.item_count !== 'undefined') {
        const cartCountBadge = document.querySelector('.sensen-header__cart-count-badge');
        if (cartCountBadge) {
          cartCountBadge.textContent = cart.item_count;
          cartCountBadge.style.display = cart.item_count > 0 ? '' : 'none';
        }
      }

      if (!cart || !cart.items || cart.items.length === 0) return;

      let itemToShow = cart.items[0];
      if (lastAddedItemData && lastAddedItemData.productVariantId) {
        const found = cart.items.find(i => String(i.variant_id) === String(lastAddedItemData.productVariantId));
        if (found) itemToShow = found;
      } else if (lastAddedItemData && lastAddedItemData.id) {
        const found = cart.items.find(i => String(i.id) === String(lastAddedItemData.id) || String(i.variant_id) === String(lastAddedItemData.id));
        if (found) itemToShow = found;
      }

      this.renderItem(itemToShow, cart);
      this.open();
    } catch (err) {
      console.error('Error fetching cart for popup notification:', err);
    }
  }

  renderItem(item, cart) {
    if (!this.bodyEl) return;

    const imgLinkEl = this.bodyEl.querySelector('[data-cart-item-link]');
    const imgEl = this.bodyEl.querySelector('[data-cart-item-img]');
    const titleEl = this.bodyEl.querySelector('[data-cart-item-title]');
    const variantEl = this.bodyEl.querySelector('[data-cart-item-variant]');
    const qtyEl = this.bodyEl.querySelector('[data-cart-item-qty]');
    const priceEl = this.bodyEl.querySelector('[data-cart-item-price]');

    const imgUrl = this.getSizedImageUrl(item.featured_image?.url || item.image, 160);
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

    if (imgLinkEl) imgLinkEl.href = item.url || '#';

    if (imgEl) {
      imgEl.hidden = true;
      imgEl.removeAttribute('src');
      if (imgUrl) {
        imgEl.src = imgUrl;
        imgEl.alt = item.product_title || '';
        imgEl.hidden = false;
      }
    }

    if (titleEl) {
      titleEl.textContent = item.product_title || '';
      titleEl.href = item.url || '#';
    }

    if (variantEl) {
      if (variantTitle) {
        variantEl.textContent = variantTitle;
        variantEl.hidden = false;
      } else {
        variantEl.hidden = true;
      }
    }

    if (qtyEl) {
      qtyEl.textContent = item.quantity;
    }

    if (priceEl) {
      priceEl.textContent = this.formatMoney(item.final_line_price);
    }

    if (this.subtotalEl) {
      this.subtotalEl.textContent = this.formatMoney(cart.total_price);
    }
  }

  reset() {
    if (!this.bodyEl) return;
    const imgEl = this.bodyEl.querySelector('[data-cart-item-img]');
    const titleEl = this.bodyEl.querySelector('[data-cart-item-title]');
    const variantEl = this.bodyEl.querySelector('[data-cart-item-variant]');
    const qtyEl = this.bodyEl.querySelector('[data-cart-item-qty]');
    const priceEl = this.bodyEl.querySelector('[data-cart-item-price]');

    if (imgEl) {
      imgEl.hidden = true;
      imgEl.removeAttribute('src');
    }
    if (titleEl) titleEl.textContent = '';
    if (variantEl) {
      variantEl.textContent = '';
      variantEl.hidden = true;
    }
    if (qtyEl) qtyEl.textContent = '';
    if (priceEl) priceEl.textContent = '';
  }

  open() {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }

    const header = document.querySelector('.sensen-header-container');
    if (header) {
      header.classList.remove('is-hidden');
    }

    this.popup.style.display = '';
    requestAnimationFrame(() => {
      this.popup.setAttribute('aria-hidden', 'false');
    });

    if (!this.isHovered) {
      this.autoCloseTimer = setTimeout(() => {
        this.close();
      }, 6000);
    }
  }

  close() {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
    this.popup.setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      if (this.popup.getAttribute('aria-hidden') === 'true') {
        this.popup.style.display = 'none';
        this.reset();
      }
    }, 300);
  }
}

const initSensenCartNotification = () => {
  if (!window.sensenCartNotification) {
    window.sensenCartNotification = new SensenCartNotification();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSensenCartNotification);
} else {
  initSensenCartNotification();
}
